module.exports = __webpack_public_path__ + "static/media/20pic.cd9b521a.jpg";